(function () {
  'use strict';

  var REGISTER_URL = 'https://app.keslercpareview.com/register';
  var STORAGE_KEY = 'kesler_registration_attribution_v1';
  var MARKETING_HOSTS = ['keslercpareview.com', 'www.keslercpareview.com'];
  var LEGACY_TRIAL_PATHS = [
    '/trial',
    '/trial/',
    '/pages/trial-keslerqs',
    '/pages/trial-keslerqs/'
  ];
  var ATTRIBUTION_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'cmc_clid',
    'cmc_vid',
    'cmc_tid',
    'cmc_ref',
    'gclid',
    'gbraid',
    'wbraid',
    'fbclid',
    'msclkid',
    'ttclid'
  ];
  var LEGACY_PASSTHROUGH_KEYS = ATTRIBUTION_KEYS.concat([
    'ref',
    'referral',
    'referral_code',
    'from'
  ]);

  function normalizeValue(value) {
    if (typeof value !== 'string' || !value || value.length > 512) return '';
    return value;
  }

  function pickAllowed(params, keys) {
    var values = {};

    keys.forEach(function (key) {
      var value = normalizeValue(params.get(key));
      if (value) values[key] = value;
    });

    return values;
  }

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|;\\s*)' + name + '=([^;]*)')
    );

    if (!match) return '';

    try {
      return normalizeValue(decodeURIComponent(match[1]));
    } catch (error) {
      return normalizeValue(match[1]);
    }
  }

  function getStoredAttribution() {
    var stored;
    var allowed = {};

    try {
      stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    } catch (error) {
      return allowed;
    }

    ATTRIBUTION_KEYS.forEach(function (key) {
      var value = normalizeValue(stored[key]);
      if (value) allowed[key] = value;
    });

    return allowed;
  }

  function captureCurrentAttribution() {
    var current = pickAllowed(
      new URLSearchParams(window.location.search),
      ATTRIBUTION_KEYS
    );

    if (Object.keys(current).length) {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(current));
      } catch (error) {}
    }

    return current;
  }

  var currentAttribution = captureCurrentAttribution();

  function getClickMagickInfo() {
    var info = {};

    try {
      if (
        window.clickmagick_cmc &&
        typeof window.clickmagick_cmc.getInfo === 'function'
      ) {
        info = window.clickmagick_cmc.getInfo() || {};
      }
    } catch (error) {}

    return info;
  }

  function getAttribution() {
    var values = getStoredAttribution();
    var clickMagickInfo = getClickMagickInfo();

    ATTRIBUTION_KEYS.forEach(function (key) {
      if (currentAttribution[key]) values[key] = currentAttribution[key];
    });

    ['cmc_clid', 'cmc_vid', 'cmc_tid', 'cmc_ref'].forEach(function (key) {
      var cookieValue = getCookie(key);
      if (!values[key] && cookieValue) values[key] = cookieValue;
    });

    if (!values.cmc_clid) {
      values.cmc_clid = normalizeValue(clickMagickInfo.cmc_clid);
    }
    if (!values.cmc_vid) {
      values.cmc_vid = normalizeValue(
        clickMagickInfo.cmc_vid || clickMagickInfo.vid
      );
    }
    if (!values.cmc_tid) {
      values.cmc_tid = normalizeValue(clickMagickInfo.cmc_tid);
    }
    if (!values.cmc_ref) {
      values.cmc_ref = normalizeValue(clickMagickInfo.cmc_ref);
    }

    return values;
  }

  function isDirectRegisterUrl(url) {
    return (
      url.protocol === 'https:' &&
      url.hostname === 'app.keslercpareview.com' &&
      (url.pathname === '/register' || url.pathname === '/register/')
    );
  }

  function isLegacyTrialUrl(url) {
    return (
      MARKETING_HOSTS.indexOf(url.hostname) !== -1 &&
      LEGACY_TRIAL_PATHS.indexOf(url.pathname) !== -1
    );
  }

  function getRegistrationDestination(originalUrl) {
    var destination;
    var legacyValues;

    if (isDirectRegisterUrl(originalUrl)) return originalUrl;
    if (!isLegacyTrialUrl(originalUrl)) return null;

    destination = new URL(REGISTER_URL);
    legacyValues = pickAllowed(
      originalUrl.searchParams,
      LEGACY_PASSTHROUGH_KEYS
    );

    Object.keys(legacyValues).forEach(function (key) {
      destination.searchParams.set(key, legacyValues[key]);
    });

    return destination;
  }

  function decorateRegisterLink(link) {
    var originalUrl;
    var destination;
    var attribution;
    var sourcePage;
    var sourceCta;

    try {
      originalUrl = new URL(link.getAttribute('href'), window.location.href);
    } catch (error) {
      return;
    }

    destination = getRegistrationDestination(originalUrl);
    if (!destination) return;

    attribution = getAttribution();
    ATTRIBUTION_KEYS.forEach(function (key) {
      if (attribution[key] && !destination.searchParams.has(key)) {
        destination.searchParams.set(key, attribution[key]);
      }
    });

    sourcePage = normalizeValue(window.location.pathname);
    if (sourcePage && !destination.searchParams.has('ks_src_page')) {
      destination.searchParams.set('ks_src_page', sourcePage);
    }

    sourceCta = normalizeValue(link.getAttribute('data-attribution-id'));
    if (sourceCta && !destination.searchParams.has('ks_src_cta')) {
      destination.searchParams.set('ks_src_cta', sourceCta);
    }

    link.setAttribute('href', destination.toString());
  }

  function decorateAllRegisterLinks() {
    document.querySelectorAll('a[href]').forEach(decorateRegisterLink);
  }

  function decorateEventLink(event) {
    var link;

    if (!(event.target instanceof Element)) return;
    link = event.target.closest('a[href]');
    if (link) decorateRegisterLink(link);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorateAllRegisterLinks);
  } else {
    decorateAllRegisterLinks();
  }

  // Re-read ClickMagick values immediately before pointer, keyboard, or new-tab navigation.
  document.addEventListener('pointerdown', decorateEventLink, true);
  document.addEventListener('click', decorateEventLink, true);
  document.addEventListener('auxclick', decorateEventLink, true);
})();
